import * as React from 'react'

import { AccessibleVideo, } from '../../../../../../Shared/index'
import { DIAGNOSTIC_ANIMATION_VIDEO, DIAGNOSTIC_ON_LAPTOP } from '../asset_constants'

const BeginWithADiagnosticSlide = ({ paragraphs, slideGroupClassName, }) => (
  <section className={`slide ${slideGroupClassName} begin-with-a-diagnostic-slide`} key="begin-with-a-diagnostic-slide">
    <div>
      <h1>Begin with a diagnostic to pinpoint student writing skill gaps</h1>
      <div className="flex-wrapper">
        <div className='video-section'>
          <AccessibleVideo
            ariaLabel="Animation of a user reviewing and assigning follow-up recommendations after students have completed a Quill Diagnostic activity"
            src={DIAGNOSTIC_ANIMATION_VIDEO}
          />
        </div>
        <div className="text">
          {paragraphs}
        </div>
      </div>
    </div>
  </section>
)

export default BeginWithADiagnosticSlide
